import Image from './_image.js'

export default {
  name: 'BetStatusIcon',
  values: {
    lost: {
      configSet: Image,
      configValues: {
        src: 'leg-status-lost-icon',
      },
    },
    open: {
      configSet: Image,
      configValues: {
        src: 'leg-status-open-icon',
      },
    },
    void: {
      configSet: Image,
      configValues: {
        src: 'leg-status-void-icon',
      },
    },
    won: {
      configSet: Image,
      configValues: {
        src: 'leg-status-won-icon',
      },
    },
    cashedOut: {
      configSet: Image,
      configValues: {
        src: 'leg-status-cashed-out-icon',
      },
    },
  },
  meta: {
    extendable: false,
  },
}
